module.exports = __webpack_public_path__ + "static/WelcomeToElk9-53e364fe7767228224b6a0c66dc30a0c.webp";